import { FunctionComponent } from "react";
import { Stack } from "@mui/material";
import { CloseDialogHandler } from "Infrastructure/Providers/DialogProvider/DialogProvider";
import ActionHistoryTable from "./ActionHistoryTable";

interface Props {
	closeDialog: CloseDialogHandler;
}

const ActionHistoryDialogContent: FunctionComponent<Props> = (props) => {
	const { closeDialog } = props;

	return (
		<Stack direction="column" sx={{ minWidth: 800, minHeight: 600 }}>
			<ActionHistoryTable />
		</Stack>
	);
};

export default ActionHistoryDialogContent; 